import { gql } from '@apollo/client'

export const CHECK_VERSION = gql`
  query checkVersion {
    checkVersion {
      newVersion
      oldVersion
    }
  }
`
